class e {
  static toOptionalDate(t) {
    if (t !== void 0)
      return e.toDate(t);
  }
  static toDate(t) {
    return new Date(t * 1e3);
  }
}
function n(r) {
  return new r();
}
export {
  e as Adapter,
  n as getAdapter
};
//# sourceMappingURL=adapter.js.map
